export const HYDRATE_GUESTLIST = 'HYDRATE_GUESTLIST';
export const UPDATE_SEARCH_TEXT = 'UPDATE_SEARCH_TEXT';



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/guestlist/constants.es6